export default "__VITE_ASSET__Cr$SnP7Q__"